import React from 'react'
import * as UIcons from '@iconscout/react-unicons'
import Btn from 'components/Btn'
import { useFormContext } from 'react-hook-form'
import { withTranslation } from 'react-i18next'

let img

export default withTranslation()(function FileUpload({ t, name, label, style, padding= '10' }) {
  const { register, watch, setValue } = useFormContext()
  console.log('Watching for image value', watch(name))
  img = watch(name)
  return (
    <div className="grid grid-cols-3 gap-3" style={style}>
      <div className={`${img ? 'col-span-2' : 'col-span-3'}`}>
        <label
          htmlFor={name}
          className="mb-2 block text-sm text-sexcondary"
        >
          {label}
        </label>
        <label
          htmlFor={name}
          className={`p-${padding} w-full text-center rounded-xl bg-primary bg-opacity-5 justify-center text-primary border-2 border-dashed flex font-medium border-primary`}
        >
          <UIcons.UilPaperclip className="text-primary mr-2" />
          <span className="">{t('misc.upload')}</span>
        </label>
        <input type="file" name={name} id={name} className="hidden" hidden {...register(name)} />
      </div>

      {
        img && <div className="relative p-5">
          <Btn
            content={() => <UIcons.UilTimes />}
            className="absolute top-0 right-0 text-body-text p-0 hover:bg-default h-100"
            click={() => setValue(name, '')}
          />

          {
            watch('type') === 'flyer' ? <img src={URL?.createObjectURL(img[0])} alt="" /> : (
              <video src={URL?.createObjectURL(img[0])} controls />
            )
          }

        </div>
      }
    </div>
  )
})
